import {
  CERTIFICADO_SUCCESS,
  CERTIFICADO_LOADING,
  CERTIFICADO_ERROR,
  CERTIFICADO_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import certificadoInitialState from "../initialStates/certificadoInitialState";

const certificado = (state, { payload, type }) => {
  switch (type) {
    case CERTIFICADO_LOADING:
      return {
        ...state,
        certificados: {
          ...state.certificados,
          error: false,
          loading: true,
        },
      };
    case CERTIFICADO_SUCCESS:
      return {
        ...state,
        certificados: {
          ...state.certificados,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case CERTIFICADO_ERROR:
      return {
        ...state,
        certificados: {
          ...state.certificados,
          error: payload,
          loading: false,
        },
      };
    case CERTIFICADO_RESET:
      return certificadoInitialState;
    case RESET_PORTAL_CONTEXT:
      return certificadoInitialState;
    default:
      return state;
  }
};

export default certificado;
